import { Cacheable } from "../../../../lib/cache/cacheable.cls";
import { Process } from "../../../../lib/process/process.cls";
export class FifoCache extends Process {
    /**
    * Constructor detail
    * @param iProvider
    * @param config
    * config param must be passed in as object:
    *  {
    *    refreshInterval: 120000,
    *    maxAge: 30000,
    *    restartDelay: 30000
    *  }
    */
    constructor(iProvider) {
        super(iProvider);
        /**
         * @Override
         * key object mappings of the cache
         */
        this.cacheEntries = {};
        /**
         * @Override
         * revalidate all cachd items
         */
        this.revalidateCache = () => {
            this.log(FifoCache.TAG, 'revalidate', this.cacheEntries);
            const validator = this.iProvider.itemValidator;
            try {
                for (let key in this.cacheEntries) {
                    try {
                        validator.validate(this.cacheEntries[key]);
                    }
                    catch (ex) {
                        this.log(FifoCache.TAG, 'revalidate EX', ex);
                    }
                }
            }
            catch (exo) {
                this.log(FifoCache.TAG, 'revalidate EXO', exo);
            }
        };
        this.log(FifoCache.TAG, 'pid', this.settings.pid);
    }
    /**
     * @Override
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    start(params) {
        this.log(FifoCache.TAG, 'start', params);
        this.settings = params;
        try {
            // make sure we're stopped
            this.stop();
            this.intervalMonitor =
                setInterval(this.revalidateCache, this.settings.refreshInterval);
        }
        catch (ex) {
            this.log(FifoCache.TAG, 'error starting cache', ex.message);
            let st = setTimeout(() => {
                clearTimeout(st);
            }, this.settings.restartDelay);
        }
    }
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    stop(params) {
        try {
            if (this.intervalMonitor !== null) {
                clearInterval(this.intervalMonitor);
                this.intervalMonitor = null;
            }
            this.log(FifoCache.TAG, "stop done");
        }
        catch (ex) {
            this.log(FifoCache.TAG, 'error stopping cache', ex.message);
        }
    }
    /**
     * @Override
     * return key -> object mapping of the whole cache
     */
    getItems() {
        return this.cacheEntries;
    }
    /**
     * @Override
     * return key -> object mapping of the whole cache
     * @param key
     */
    getItem(key) {
        if (!this.cacheEntries.hasOwnProperty(key)) {
            return null;
        }
        else {
            return this.cacheEntries[key];
        }
    }
    /**
     * @Override
     * add a new entry to the cache with or without associated object
     * and optional expiration time.
     * if the key already exists the itemValidator will patch it
     * @param key
     * @param item new data or not provided so we create a default
     * @param maxAge
     */
    addItem(key, item, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        item = (typeof item === 'undefined') ? { i: key } : item;
        if (!this.cacheEntries.hasOwnProperty(key)) {
            this.cacheEntries[key] =
                new Cacheable(key, item, this.iProvider.itemValidator.getNowMs(), maxAge);
            this.iProvider.refresh(this.cacheEntries[key]);
        }
        else {
            this.iProvider.itemValidator.
                patchItem(this.cacheEntries[key], item);
        }
    }
    /**
     * @Override
     * add a new entries to the cache with or without associated object
     * and optional expiration time
     * @param mappings
     * @param maxAge
     */
    addItems(mappings, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        for (let p in mappings) {
            this.addItem(p, mappings[p], maxAge);
        }
    }
    /**
     * @Override
     * remove a single cache entry
     * @param key
     */
    removeItem(key) {
        try {
            delete this.cacheEntries[key];
        }
        catch (ex) {
            return false;
        }
        return true;
    }
    /**
     * @Override
     * remove a list of cache entries
     * @param keys
     */
    removeItems(keys) {
        keys.map(k => {
            this.removeItem(k);
        });
        return true;
    }
    /**
     * @Override
     * return all cache keys as array
     * @param mappings
     */
    getConvertedValue(mappings) {
        const res = [];
        const cacheEn = this.cacheEntries;
        const mappingsReverse = mappings.split("-")[1] + "-" + mappings.split("-")[0];
        for (let p in cacheEn) {
            console.log("find this in simple", p, mappings);
            console.log("find this in reverse", p, mappingsReverse);
            if (p == mappings) {
                console.log("find this in simple", p, mappings);
                res.push(cacheEn[p].item);
                return res[0];
            }
            else if (p == mappingsReverse) {
                console.log("find this in reverse", p, mappingsReverse);
                cacheEn[p].item.B = 1 / cacheEn[p].item.B;
                res.push(cacheEn[p].item);
                return res[0];
            }
            else {
                console.log("find any other and pass this", p, mappings);
                res.push(cacheEn[p].item);
                return undefined;
            }
        }
    }
    asKeysArray(mappings) {
        const res = [];
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            res.push(p);
        }
        return res;
    }
    /**
     * @Override
     * return all cached objects as array
     * @param mappings
     */
    asObjectArray(mappings) {
        const res = [];
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            res.push(mappings[p]);
        }
        return res;
    }
    /**
     * @Override
     * return all cached objects key as symbol name and value as latest price
     * @param mappings
    */
    CheckOrderEligibilty(mappings) {
        const res = {};
        const mainIsin = [mappings.send.currency + '-' + mappings.recive];
        const mainIsinReverse = [mainIsin[0].split("-")[1] + "-" + mainIsin[0].split("-")[0]];
        const cacheMappings = this.cacheEntries;
        let qtyAsked = mappings.free_Margin;
        let qtyRemaining = qtyAsked;
        let qtyFilled = [];
        let qtyFilledPrice = [];
        let weigthedAvg = [];
        let maxBuy = 0;
        let orderBookSell = [];
        let qtyArr = [];
        var isThisSell = 0;
        for (let p in cacheMappings) {
            if (mainIsin.indexOf(p) != -1) {
                // res[p] = this.cacheEntries[p].item
                orderBookSell = this.cacheEntries[p].item.DPB;
            }
            else if (mainIsinReverse.indexOf(p) != -1) {
                // res[p] = this.cacheEntries[p].item
                orderBookSell = this.cacheEntries[mainIsinReverse[0]].item.DPS;
                this.cacheEntries[mainIsinReverse[0]].item.B = 1 / this.cacheEntries[mainIsinReverse[0]].item.B;
                res['B'] = this.cacheEntries[mainIsinReverse[0]].item.B;
                isThisSell = 1;
            }
            for (var i = 0; i < orderBookSell.length; i++) {
                maxBuy = maxBuy + orderBookSell[i].Quantity;
                qtyArr.push(orderBookSell[i].Quantity);
                if (isThisSell) {
                    orderBookSell[i].Rate = 1 / orderBookSell[i].Rate;
                }
                if (qtyRemaining > orderBookSell[i].Quantity) {
                    qtyRemaining = Math.abs(orderBookSell[i].Quantity - qtyRemaining);
                    qtyFilled.push(orderBookSell[i].Quantity);
                    qtyFilledPrice.push(orderBookSell[i].Rate);
                    weigthedAvg.push(orderBookSell[i].Quantity * orderBookSell[i].Rate);
                }
                if (qtyRemaining < orderBookSell[i].Quantity) {
                    qtyFilled.push(qtyRemaining);
                    qtyFilledPrice.push(orderBookSell[i].Rate);
                    weigthedAvg.push(qtyRemaining * orderBookSell[i].Rate);
                    qtyRemaining = 0;
                }
                else if (qtyRemaining == orderBookSell[i].Quantity) {
                    qtyFilled.push(qtyRemaining);
                    qtyFilledPrice.push(orderBookSell[i].Rate);
                    qtyRemaining = qtyRemaining;
                    weigthedAvg.push(qtyRemaining * orderBookSell[i].Rate);
                }
            }
            // if(mappings.freeMargin > maxBuy){
            //   mappings.free_Margin = maxBuy
            // }
            console.log(weigthedAvg);
            res['B'] = weigthedAvg.reduce((a, b) => a + b, 0);
            res['MAX'] = maxBuy;
            if (isThisSell) {
                res['MAX'] = maxBuy;
            }
        }
        return res;
    }
    asKeysValueArray(mappings) {
        const res = {};
        const mainIsin = [mappings.send.currency + '-' + mappings.recive];
        const mainIsinReverse = [mainIsin[0].split("-")[1] + "-" + mainIsin[0].split("-")[0]];
        const cacheMappings = this.cacheEntries;
        var qtyAsked = 1;
        var qtyRemaining = qtyAsked;
        var qtyFilled = [];
        var qtyFilledPrice = [];
        var weigthedAvg = [];
        var maxBuy = 0;
        let orderBookSell = [];
        let qtyArr = [];
        for (let p in cacheMappings) {
            if (mainIsin.indexOf(p) != -1) {
                console.log("It's normal over here", p);
                // res[p] = this.cacheEntries[p].item
                res['B'] = this.cacheEntries[p].item.B;
                orderBookSell = this.cacheEntries[p].item.DPS;
            }
            else if (mainIsinReverse.indexOf(p) != -1) {
                // res[p] = this.cacheEntries[p].item
                orderBookSell = this.cacheEntries[mainIsinReverse[0]].item.DPB;
                this.cacheEntries[mainIsinReverse[0]].item.B = 1 / this.cacheEntries[mainIsinReverse[0]].item.B;
                res['B'] = this.cacheEntries[mainIsinReverse[0]].item.B;
            }
            for (var i = 0; i < orderBookSell.length; i++) {
                maxBuy = maxBuy + orderBookSell[i].Quantity;
                // qtyArr.push(orderBookSell[i].Quantity)
                // if(qtyRemaining > orderBookSell[i].Quantity){
                //   qtyRemaining = Math.abs(orderBookSell[i].Quantity - qtyRemaining)
                //   qtyFilled.push(orderBookSell[i].Quantity)
                //       qtyFilledPrice.push(orderBookSell[i].Rate)
                //       weigthedAvg.push(orderBookSell[i].Quantity*orderBookSell[i].Rate)
                //   } 
                //   if(qtyRemaining < orderBookSell[i].Quantity){
                //   qtyFilled.push(qtyRemaining)
                //       qtyFilledPrice.push(orderBookSell[i].Rate)
                //       weigthedAvg.push(qtyRemaining*orderBookSell[i].Rate)
                //       qtyRemaining = 0
                //   } 
                // else if(qtyRemaining == orderBookSell[i].Quantity){
                //       qtyFilled.push(qtyRemaining)
                //       qtyFilledPrice.push(orderBookSell[i].Rate)
                //       qtyRemaining = qtyRemaining
                //       weigthedAvg.push(qtyRemaining*orderBookSell[i].Rate)
                //   }
            }
            // if(mappings.freeMargin > maxBuy){
            //   mappings.free_Margin = maxBuy
            // }
            res['MAX'] = maxBuy;
        }
        return res;
    }
    asKeysValueArrayAll(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'INDICIES')
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
            else
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    }
    getCryptoCurrency(mappings) {
        const res = {};
        const mainIsin = [mappings.send.currency + '-' + mappings.recive];
        const mainIsinReverse = [mainIsin[0].split("-")[1] + "-" + mainIsin[0].split("-")[0]];
        const cacheMappings = this.cacheEntries;
        var qtyAsked = 1;
        var qtyRemaining = qtyAsked;
        var qtyFilled = [];
        var qtyFilledPrice = [];
        var weigthedAvg = [];
        var maxBuy = 0;
        let orderBookSell = [];
        let qtyArr = [];
        for (let p in cacheMappings) {
            if (mainIsin.indexOf(p) != -1) {
                // res[p] = this.cacheEntries[p].item
                orderBookSell = this.cacheEntries[p].item.DPS;
            }
            else if (mainIsinReverse.indexOf(p) != -1) {
                // res[p] = this.cacheEntries[p].item
                orderBookSell = this.cacheEntries[mainIsinReverse[0]].item.DPB;
                this.cacheEntries[mainIsinReverse[0]].item.B = 1 / this.cacheEntries[mainIsinReverse[0]].item.B;
                res['B'] = this.cacheEntries[mainIsinReverse[0]].item.B;
            }
        }
        return res['orderBook'] = orderBookSell;
    }
    getCommodity(mappings) {
        // const res: any = {}
        // const mainIsin: any = ["XAUUSD","XAGUSD","USOUSD","UKOUSD","XNGUSD"]
        // mappings = mappings || this.cacheEntries 
        // for (let p in mappings) {
        //   if(mainIsin.indexOf(p) != -1){
        //     res[p] = this.cacheEntries[p].item
        //   }
        // }
        // return res
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            //console.log(this.cacheEntries[p].item.other.type)
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'Commodities')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    }
    getCommodityAll(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            //console.log(this.cacheEntries[p].item.other.type)
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'Commodities')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    }
    getCryptoDepth(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            // console.log(this.cacheEntries[p])
            if (p == 'depth')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    }
    getIndices(mappings) {
        const res = {};
        const mainIsin = ["SPXUSD", "D30EUR", "100GBP", "H50HKD", "U30USD"];
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            if (mainIsin.indexOf(p) != -1) {
                if (!this.cacheEntries[p].item.other)
                    continue;
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
            }
        }
        return res;
    }
    getIndicesAll(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'INDICIES')
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
        }
        return res;
    }
    getCurrencies(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'currencies')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    }
    getSegmentType(mappings) {
        const res = {};
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            res[p] = this.cacheEntries[p].item.other.type;
        }
        return res;
    }
    getAllcurrency(mappings) {
        const res = [];
        mappings = mappings || this.cacheEntries;
        for (let p in mappings) {
            if (this.cacheEntries[p].item.other && this.cacheEntries[p].item.other.type == 'currencies') {
                if (res.indexOf(this.cacheEntries[p].key.substring(0, 3)) == -1)
                    res.push(this.cacheEntries[p].key.substring(0, 3));
                if (res.indexOf(this.cacheEntries[p].key.substring(3, 6)) == -1)
                    res.push(this.cacheEntries[p].key.substring(3, 6));
            }
        }
        return res;
    }
    /**
     * @Override
     * authenticate using the credentials from params
     * @param params must contain credentials in case process needs auth
     */
    auth(params) { }
}
// log tag
FifoCache.TAG = 'FifoCache';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-cache.cls.ts
// module id = null
// module chunks = 